import { Box } from '@chakra-ui/react';
import { useCQMediaQuery } from '@laxmimanogna/code-quick-components';
import React from 'react';

const CQContainer = props => {
  const marginHorizontal = useCQMediaQuery({
    lg: '12%',
    md: '6%',
    sm: '2%',
  });

  return (
    <Box ref={props.ref} py={25} px={30} mx={marginHorizontal} {...props} />
  );
};

CQContainer.propTypes = {
  ...Box.propTypes,
};

export default CQContainer;
